import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_MULTIPLE_CLIENTS_REPORT } from '../types';
import { getMultipleClientsReportPending, getMultipleClientsReportFulfilled, getMultipleClientsReportRejected } from '../actions';
import { sendApiRequest, notifyError } from '../../../actions';
import { multipleClientsReportFiltersSelector } from '../selectors';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'report/getMultipleClientsReport',
  onSuccess: [response => {
    // if (response.data.clientReports.length === 0) {
    //   return notifyWarning(MULTIPLE_CLIENTS_REPORT_MESSAGES.NOT_FOUND);
    // }
    return getMultipleClientsReportFulfilled(response)
  }],
  onError: [
    getMultipleClientsReportRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getMultipleClientsReportEpic$ = (action$, state$) => action$.pipe(
  ofType(GET_MULTIPLE_CLIENTS_REPORT.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => {
    const filters = multipleClientsReportFiltersSelector(state$.value);
    return merge(
      of(getMultipleClientsReportPending()),
      of(sendApiRequest(createPayload({ ...payload, ...filters }), meta)),
    );
  }),
);

export default getMultipleClientsReportEpic$;


// WEBPACK FOOTER //
// ./src/features/reports/epics/getMultipleClientsReportEpic.js